<template>
  <div class="header-content" :class="{ 'fixed-header': isHome,'mobileCss':isMobileFlg }">
    <div class="header-content-wrap flex">
      <div class="header-left flex-0">
        <img
          :src="'./static/images/logo_white.png?time=' + baseConfigInfo.setImgPathRandom"
          alt=""
          srcset=""
          v-if="isHome"
        />
        <img :src="'./static/images/logo.png?time=' + baseConfigInfo.setImgPathRandom" alt="" srcset="" v-else />
      </div>
      <div class="header-right flex flex-0">
        <div
          class="enter-list flex"
          v-if="!isWidth1000"
          :class="{ white: isHome }"
        >
          <div
            v-for="item in enterList"
            :key="item.code"
            class="enter-list-item hand flex-0"
            :class="{ 'active fw_600': currentPage === item.code }"
            @click.stop="handleGopage(item, item.url)"
          >
            <span class="title_1">
              {{ $t(`homePage.${item.name}.name`) }}
            </span>
            <ul
              class="children-list"
              v-if="item.children"
              :class="{ 'ie-children-list': isIE }"
            >
              <li
                class="children-list-item tc flex-0"
                v-for="(el, elIndex) in item.children"
                :key="elIndex"
                @click.stop="handleGopage(item, el.url)"
                :class="{ white: isHome }"
              >
                {{
                  $t(
                    `homePage.${item.name}.childrenList[${elIndex}].${el.name}`
                  )
                }}
              </li>
            </ul>
          </div>
        </div>
        <div v-else class="menu-content" @click="enterDrawer = true" >
          <!-- <i
            class="el-icon-s-operation hand"
            :style="{ color: isHome ? '#fff' : null }"
          ></i> -->
          <svg t="1723446384552" class="hand" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4305" width="50" height="48"><path d="M64 64h896v128H64V64z m0 768h896v128H64v-128z m0-384h896v128H64V448z" :fill="isHome ? '#fff' : '' "></path></svg>
        </div>
        <div class="language-list flex" :class="isMobileFlg?'isMobileCss':''">
          <template v-if="isHome">
            <img
              :src="'./static/images/jian_white.png?time=' + baseConfigInfo.setImgPathRandom"
              alt=""
              srcset=""
              class="hand flex-0"
              @click="changeLang('zn')"
            />
            <img
              :src="'./static/images/fan_white.png?time=' + baseConfigInfo.setImgPathRandom"
              alt=""
              srcset=""
              class="hand flex-0"
              @click="changeLang('tw')"
            />
            <img
              :src="'./static/images/en_white.png?time=' + baseConfigInfo.setImgPathRandom"
              alt=""
              srcset=""
              class="hand flex-0"
              @click="changeLang('en')"
            />
          </template>
          <template v-else>
            <img
              :src="'./static/images/jian.png?time=' + baseConfigInfo.setImgPathRandom"
              alt=""
              srcset=""
              class="hand flex-0"
              @click="changeLang('zn')"
            />
            <img
              :src="'./static/images/fan.png?time=' + baseConfigInfo.setImgPathRandom"
              alt=""
              srcset=""
              class="hand flex-0"
              @click="changeLang('tw')"
            />
            <img
              :src="'./static/images/en.png?time=' + baseConfigInfo.setImgPathRandom"
              alt=""
              srcset=""
              class="hand flex-0"
              @click="changeLang('en')"
            />
          </template>
        </div>
      </div>
    </div>
    <div class="swiper-container" v-show="!isHome">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="imgItem in bannerData" :key="imgItem">
          <div
            class="swiper-slide-img"
            :style="
              'background:url(' +
              editImgUrl(imgItem) +
              ') center / cover no-repeat'
            "
          ></div>
          <!-- <img :src="require('@/assets/images/banners/' + imgItem + '.png')" alt="" srcset="" class="swiper-slide-img" /> -->
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="header-line" v-if="!isHome"></div>
    <!-- 弹层 -->
    <div
      class="popup-mobile"
      :class="enterDrawer ? 'show' : 'close'"
      ref="popupMobile"
      v-if="isWidth1000"
    >
      <div class="close-icon tr">
        <i class="el-icon-circle-close hand" @click="handleClose"></i>
      </div>
      <div class="mobile-enter-list">
        <div
          class="mobile-list-item"
          v-for="(mobileEnterItem, index) in enterList"
          :key="'mobileEnter' + index"
        >
          <div
            class="first-level-name hand"
            @click.stop="handleGopage(mobileEnterItem, mobileEnterItem.url)"
          >
            {{ $t(`homePage.${mobileEnterItem.name}.name`) }}
          </div>
          <div class="children-list">
            <div
              class="children-list-item hand"
              v-for="(el, elIndex) in mobileEnterItem.children"
              :key="elIndex + 'child'"
              @click.stop="handleGopage(mobileEnterItem, el.url)"
            >
              {{
                $t(
                  `homePage.${mobileEnterItem.name}.childrenList[${elIndex}].${el.name}`
                )
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from '../../../static/swiper/js/swiper'
import '../../../static/swiper/css/swiper.css'
import $ from 'jquery'
export default {
  name: 'Header',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      enterList: [],
      currentPage: '01',
      bannerData: [
        'banner_01',
        'banner_02',
        'banner_03',
        'banner_04',
        'banner_05',
        'banner_06'
      ],
      mySwiper: '',
      isWidth1000: false,
      enterDrawer: false,
      isMobileFlg:false
    }
  },
  computed: {
    editImgUrl() {
      return (imgItem) => {
        return this.$baseStaticUrl + '/frontImages/banners/' + imgItem + '.png?time=' + this.baseConfigInfo.setImgPathRandom
      }
    },
    baseConfigInfo() {
      return (
        localStorage.getItem('baseConfigInfo') &&
        JSON.parse(localStorage.getItem('baseConfigInfo'))
      )
    },
    isHome() {
      return this.$route.path === '/' || this.$route.name === 'default'
    },
    isIE() {
      return this.$isIE()
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        // 更新当前头部指引
        let currentInfo =
          this.baseConfigInfo.routerList.find((el) => el.url === val.path) || {}
        if (currentInfo && Object.keys(currentInfo).length) {
          this.currentPage = currentInfo.code
        }
      }
    }
  },
  created() {
    if(this.$isMobileDevice()){
      this.isMobileFlg=true;
    }
  },
  mounted() {
    console.log(this.$i18n.locale, 'this.$i18n.locale')
    this.enterList = (this.baseConfigInfo && this.baseConfigInfo.mapList) || []
    !this.isHome && this.initSwiper()
    this.isWidth1000 = window.innerWidth <= 1000
    // 监听屏幕宽度和高度变化
    window.addEventListener('resize', this.handleResize, false)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize, false)
  },
  methods: {
    initSwiper() {
      this.mySwiper && this.mySwiper.destroy && this.mySwiper.destroy(true) // 销毁后再重建
      this.mySwiper = new Swiper('.swiper-container', {
        effect: 'fade',
        loop: true,
        autoplay: {
          disableOnInteraction: false, // 解决手动切换轮播后自动轮播失效的问题
          delay: 5000
        }
      })
      // this.mySwiper.slideTo(0, 100, false); // 滑动到第一个
      console.log('this.mySwiper', this.mySwiper)
    },
    changeLang(type) {
      this.$message.success('已切换语言');
      this.$i18n.locale = type
      localStorage.setItem('locale', type)
      this.$emit('updateWholePage', true)
      // window.location.reload();
    },
    handleGopage(item, url) {
      console.log(item.code, url)
      console.log(
        '22',
        _hmt,
        '_trackEvent',
        document.title,
        'click',
        document.title + '页面'
      )
      _hmt.push([
        '_trackEvent',
        document.title,
        'click',
        document.title + '页面'
      ])
      if (item.code === '01') {
        this.$router.push('/')
        this.currentPage = item.code
      } else if (url) {
        // 初始化轮播图
        console.log('this.mySwiper', this.mySwiper)
        this.initSwiper()
        this.$router.push(url)
        this.currentPage = item.code
      }

      this.handleClose()
    },
    // 监听屏幕宽度和高度变化
    handleResize(e) {
      this.isWidth1000 = e.target.innerWidth <= 1000
    },
    handleClose() {
      this.enterDrawer = false
    }
  }
}
</script>

<style lang="scss" scoped>
.header-content {
  .white {
    color: #fff !important;
  }

  &.fixed-header {
    position: absolute;
    top: 0;
    right: 0;
    background: transparent;
    z-index: 100;
    width: calc(100vw - 30px);
  }

  &-wrap {
    margin: 0 auto;
    max-width: 1600px;
    padding: 0 15px;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    min-height: 93px;

    .header-left {
      width: 368px;
      height: 40px;

      > img {
        width: 368px;
        height: 40px;
        display: block;
      }
    }

    .header-right {
      font-size: 16px;
      align-items: center;

      .enter-list {
        &-item {
          padding: 32px 28px;
          min-height: 93px;
          box-sizing: border-box;
          position: relative;

          &:hover {
            color: #c8a04f;

            &.active {
              color: #c8a04f;
            }

            .children-list {
              display: flex;
            }

            .ie-children-list {
              display: inline-block;

              .children-list-item {
                padding: 20px;
                &:first-child {
                  padding-left: 20px;
                }

                &:last-child {
                  padding-right: 20px;
                }
              }
            }
          }

          .title_1 {
            line-height: 29px;
          }

          &.active {
            color: #c8a04f;
          }

          .children-list {
            font-weight: normal;
            z-index: 5;
            position: absolute;
            display: none;
            left: 50%;
            -webkit-transform: translateX(-50%);
            -moz-transform: translateX(-50%);
            -o-transform: translateX(-50%);
            -ms-transform: translateX(-50%);
            transform: translateX(-50%);
            top: 93px;
            animation: fadeIn 0.6s;

            @-webkit-keyframes fadeIn {
              0% {
                opacity: 0;
              }

              100% {
                opacity: 1;
              }
            }

            @-moz-keyframes fadeIn {
              0% {
                opacity: 0;
              }

              100% {
                opacity: 1;
              }
            }

            @-o-keyframes fadeIn {
              0% {
                opacity: 0;
              }

              100% {
                opacity: 1;
              }
            }

            @-ms-keyframes fadeIn {
              0% {
                opacity: 0;
              }

              100% {
                opacity: 1;
              }
            }

            @keyframes fadeIn {
              0% {
                opacity: 0;
              }

              100% {
                opacity: 1;
              }
            }

            &-item {
              display: block;
              color: #fff;
              white-space: nowrap;
              padding: 30px;
              background: rgba(0, 0, 0, 0.7);

              &:first-child {
                padding-left: 60px;
              }

              &:last-child {
                padding-right: 60px;
              }

              &:hover {
                color: #c8a04f !important;
              }
            }
          }
        }
      }

      .language-list {
        padding: 0 15px;
        width: 156px;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        height: 93px;

        > img {
          margin: 0 5px;
          width: 22px;
          height: 22px;
          display: block;
        }
      }
    }
  }

  .swiper-container {
    width: 100%;
    height: 500px;

    .swiper-slide-img {
      height: 500px;
    }
  }

  .header-line {
    width: 100%;
    height: 80px;
    background-color: #c8a04f;
  }

  .popup-mobile {
    position: fixed;
    top: 0;
    width: 60%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.8);
    z-index: 99;
    color: #fff;
    // transition: all 0.3s linear;
    overflow: hidden;
    overflow-y: scroll;
    left: 0;

    &.show {
      width: 100%;
      padding: 10px 0 20px 10%;
      z-index: 9999;
    }

    &.close {
      width: 0;
      padding: 0;
    }

    .close-icon {
      padding: 15px 15px 0 0;

      .el-icon-circle-close {
        font-size: 80px;
        right: 45px;
        top: 35px;
        position: absolute;
      }
    }

    .mobile-enter-list {
      margin-top: -45px;
      padding-top: 30px;

      .mobile-list-item {
        font-size: 15px;

        .first-level-name {
          padding: 20px 17px;
          font-size: 42px;
        }

        .children-list {
          &-item {
            line-height: 35px;
            margin: 10px 0 30px 60px;
            font-size: 35px;
            color: rgba($color: #fff, $alpha: 0.8);
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1600px) {
  .header-content {
    &-wrap {
      min-height: 69px;

      .header-left {
        max-width: 26%;
        flex-shrink: 0;
      }

      .header-right {
        max-width: 80%;
        flex-shrink: 0;

        .enter-list {
          &-item {
            padding: 25px 12px;
            min-height: 69px;

            .children-list {
              top: 69px;
            }

            .title_1 {
              line-height: 19px;
            }
          }
        }

        .language-list {
          height: auto;
        }
      }
    }

    .swiper-container {
      height: 359px;
      overflow: hidden;

      .swiper-slide-img {
        height: 359px;
      }
    }
  }
}

@media screen and (max-width: 1400px) {
  .header-content {
    .swiper-container {
      height: 311px;

      .swiper-slide-img {
        height: 311px;
      }
    }

    &-wrap {
      width: 100vw;
      padding-top: 15px;
      flex-wrap: wrap;

      .header-left {
        max-width: 100%;
      }

      .header-right {
        max-width: 100%;

        .enter-list {
          &-item {
            &:hover {
              .children-list {
                display: inline-block;

                &-item {
                  padding: 20px;

                  &:first-child {
                    padding-left: 20px;
                  }

                  &:last-child {
                    padding-right: 20px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .header-content {
    .swiper-container {
      height: 261px;

      .swiper-slide-img {
        height: 261px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .header-content {
    &-wrap {
      width: 100vw;
      flex-wrap: wrap;

      .header-left {
        width: 100vw;
      }

      .header-right {
        padding: 15px;
        width: 100vw;
        justify-content: space-between;

        .menu-content {
          .el-icon-s-operation {
            font-size: 25px;
          }
        }
      }
    }

    .swiper-container {
      height: 199px;

      .swiper-slide-img {
        height: 199px;
      }
    }
  }
}
// 手机样式
.mobileCss .menu-content{
  position: fixed;
  right: 10px;
  top: 10px;
  padding: 20px;
  z-index: 9999;
  .el-icon-s-operation{
    font-size: 55px !important;
  }
}
.mobileCss .header-content-wrap{
  width: 100%;
  margin-bottom: 10px;
}
.mobileCss .header-content-wrap .header-left>img{
  width: unset;
  height: 50px;
}
.mobileCss .header-content{
  
}
.mobileCss .language-list.isMobileCss{
    position: absolute;
    right: 150px;
    top: 34px;
    
    img{
        width: 45px;
        height: 45px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/base/Header.vue